import React from 'react';
import { useOnboarding } from '../../../contexts/OnboardingContext';
import { useTheme } from '../../../contexts/ThemeContext';
import '../OnboardingWizard.css';

function Preferences() {
  const { data, updateStepData } = useOnboarding();
  const { theme, setTheme } = useTheme();

  // Single email notifications toggle - if enabled, all notifications are on
  const emailNotificationsEnabled = data.email_notifications?.enabled !== false;

  const handleNotificationToggle = () => {
    const newEnabled = !emailNotificationsEnabled;
    updateStepData({
      email_notifications: {
        enabled: newEnabled,
        job_alerts: newEnabled,
        interview_reminders: newEnabled,
        deadline_reminders: newEnabled,
        weekly_digest: newEnabled,
      },
    });
  };

  const handleThemeChange = (newTheme) => {
    updateStepData({ theme_preference: newTheme });
    setTheme(newTheme);
  };

  return (
    <div className="step-content">
      <div className="step-header">
        <h1 className="step-title">Almost done!</h1>
        <p className="step-subtitle">
          Set your preferences and you're ready to go.
        </p>
      </div>

      <div className="form-stack">
        {/* Email Notifications */}
        <div className="form-group">
          <label className="form-label">Email Notifications</label>
          <label className="toggle-item">
            <div className="toggle-info">
              <span className="toggle-label">Allow email notifications</span>
              <span className="toggle-description">Receive job alerts, reminders, and updates about your job search</span>
            </div>
            <div className="toggle-switch">
              <input
                type="checkbox"
                checked={emailNotificationsEnabled}
                onChange={handleNotificationToggle}
              />
              <span className="toggle-slider"></span>
            </div>
          </label>
        </div>

        {/* Theme Preference */}
        <div className="form-group">
          <label className="form-label">Theme Preference</label>
          <div className="theme-options">
            <div
              className={`theme-card ${theme === 'dark' ? 'selected' : ''}`}
              onClick={() => handleThemeChange('dark')}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && handleThemeChange('dark')}
            >
              <div className="theme-preview dark">
                <div className="preview-header"></div>
                <div className="preview-sidebar"></div>
                <div className="preview-content">
                  <div className="preview-line"></div>
                  <div className="preview-line short"></div>
                </div>
              </div>
              <span className="theme-label">Dark</span>
            </div>
            <div
              className={`theme-card ${theme === 'light' ? 'selected' : ''}`}
              onClick={() => handleThemeChange('light')}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && handleThemeChange('light')}
            >
              <div className="theme-preview light">
                <div className="preview-header"></div>
                <div className="preview-sidebar"></div>
                <div className="preview-content">
                  <div className="preview-line"></div>
                  <div className="preview-line short"></div>
                </div>
              </div>
              <span className="theme-label">Light</span>
            </div>
          </div>
        </div>

        {/* Optional Feedback */}
        <div className="form-group">
          <label className="form-label">
            What's your biggest job search challenge? <span className="label-optional">(optional)</span>
          </label>
          <textarea
            className="form-textarea"
            placeholder="Tell us what you're struggling with so we can help..."
            rows={3}
            value={data.feedback || ''}
            onChange={(e) => updateStepData({ feedback: e.target.value })}
          />
        </div>
      </div>

      <div className="completion-message">
        <div className="completion-icon">🎉</div>
        <p>Click "Complete Setup" to start your job search journey!</p>
      </div>
    </div>
  );
}

export default Preferences;
